import React from 'react';

export const UnselectedIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24">
      {/* A circle outline (stroke) with no fill */}
      <circle cx="12" cy="12" r="8" fill="none" stroke="#888" strokeWidth="2" />
    </svg>
  );
};

export const SelectedIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="8" fill="#004F71" />
    </svg>
  );
};
